<template>
     <div>
        <a-tag color="cyan" v-for="(item,index) in list" :key="index" style="margin-bottom:4px;">
        {{item.appname + '-' + item.appcode}}
        </a-tag>
   
     </div>
</template>

<script>
export default {
    data() {
        return {
            list:JSON.parse(this.authedStr)
        }
    },
    props:{
        authedStr:String
    },
};
</script>

<style lang="less" scoped>
</style> 